import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

import _ from "lodash";
import moment from "moment";

const initialState = {
    datum: moment.utc(new Date()).format(),
    view: "week",
    weekstart: 1,
    weekstart_id: null,
    kultivars: {
        loading: true,
        success: false,
        error: false,
        errordata: null,
        data: [],
        rawdata: [],
    },
    data: {
        loading: true,
        success: false,
        error: false,
        errordata: null,
        data: [],
        rawdata: [],
    },
    settings: {
        loading: true,
        success: false,
        error: false,
        errordata: null,
        data: []
    },
    vieweenheid: null,
    vieweenheid_id: null,
    eenheidkg: 1,
    eenhede: [],
    eenheidconversion: 1,
    snackbar_open: false,
    snackbar: {
        loading: false,
        success: false,
        error: false,
        errordata: null
    },
};

const addDatum = (state, action) => {
    return updateObject(state, {
        datum: moment.utc(moment(state.datum).add(1, state.view)).format()
    });
};

const subtractDatum = (state, action) => {
    return updateObject(state, {
        datum: moment.utc(moment(state.datum).subtract(1, state.view)).format()
    });
};

const setVandagDatum = (state, action) => {
    return updateObject(state, {
        datum: moment.utc(new Date()).format()
    });
};

const setDatum = (state, action) => {
    return updateObject(state, {
        datum: moment.utc(action.datum).format()
    });
};

const setWeekBeginPlukbeplan = (state, action) => {
    return updateObject(state, {
        weekstart: action.dag
    });
};

const getPlukbeplanKultivars = (state, action) => {
    return updateObject(state, {
        kultivars: {
            ...state.kultivars,
            loading: true,
        }
    });
};

const setPlukbeplanKultivars = (state, action) => {
    return updateObject(state, {
        kultivars: {
            ...state.kultivars,
            loading: false,
            success: true,
            error: false,
            errordata: null,
            data: action.kultivars,
            rawdata: action.kultivars
        }
    });
};

const setPlukbeplanKultivarsFailed = (state, action) => {
    return updateObject(state, {
        kultivars: {
            ...state.kultivars,
            loading: false,
            success: false,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            },
            data: [],
            rawdata: [],
        }
    });
};

const getPlukbeplanWeek = (state, action) => {
    return updateObject(state, {
        data: {
            ...state.data,
            loading: true,
        }
    });
};

const setPlukbeplanWeek = (state, action) => {
    let nuwedata = _.keyBy(state.kultivars.data, 'id');
    let week = moment(state.datum).isoWeekday(state.weekstart).format("W");
    if (action.week?.length > 0) {
        for (const item of action.week) {
            let nuwedaedata = {};
            let dae = action.dae.filter(itm => itm.kultivar === item.kultivar && moment(itm.datum).isoWeekday(state.weekstart).format("W") === week);
            let items = action.items.filter(itm => itm.kultivar === item.kultivar && moment(itm.datum).isoWeekday(state.weekstart).format("W") === week);
            for (let i = 0; i < 7; i++) {
                let dag = moment(state.datum).isoWeekday(state.weekstart + i).format("Y-MM-DD");
                let dagdata = dae.filter(itm => moment(itm.datum).isSame(dag, "date"));
                let dagitemsdata = items.filter(itm => moment(itm.datum).isSame(dag, "date"));
                if (dagdata?.length > 0) {
                    nuwedaedata[dag] = {
                        ...nuwedaedata[dag],
                        teiken: dagdata[0].teiken,
                        dagid: {
                            PK: dagdata[0].PK,
                            SK: dagdata[0].SK,
                        }
                    };
                }
                if (dagitemsdata?.length > 0) {
                    dagitemsdata = Object.values(_.groupBy(dagitemsdata, a => a.plaas.id));
                    nuwedaedata[dag] = {
                        ...nuwedaedata[dag],
                        items: dagitemsdata
                    };
                }
            }
            nuwedata[item.kultivar] = {
                ...nuwedata[item.kultivar],
                [week]: {
                    ...nuwedata[item.kultivar]?.[week],
                    teiken: item.teiken,
                    weekid: { PK: item.PK, SK: item.SK },
                    ...nuwedaedata
                }
            }
        }
    } else {
        for (const kultivar of Object.keys(nuwedata)) {
            let weekdata = action.week.filter(itm => moment(itm.datum).isoWeekday(state.weekstart).format("W") === week);
            let weekskryf = {};
            if (weekdata?.length > 0) {
                weekskryf = {
                    teiken: weekdata[0].teiken,
                    weekid: { PK: weekdata[0].PK, SK: weekdata[0].SK },
                };
            }
            let nuwedaedata = {};
            let dae = action.dae.filter(itm => parseInt(itm.kultivar, 10) === parseInt(kultivar, 10) && moment(itm.datum).isoWeekday(state.weekstart).format("W") === week);
            let items = action.items.filter(itm => parseInt(itm.kultivar, 10) === parseInt(kultivar, 10) && moment(itm.datum).isoWeekday(state.weekstart).format("W") === week);
            for (let i = 0; i < 7; i++) {
                let dag = moment(state.datum).isoWeekday(state.weekstart + i).format("Y-MM-DD");
                let dagdata = dae.filter(itm => moment(itm.datum).isSame(dag, "date"));
                let dagitemsdata = items.filter(itm => moment(itm.datum).isSame(dag, "date"));
                if (dagdata?.length > 0) {
                    nuwedaedata[dag] = {
                        ...nuwedaedata[dag],
                        teiken: dagdata[0].teiken,
                        dagid: {
                            PK: dagdata[0].PK,
                            SK: dagdata[0].SK,
                        }
                    };
                }
                if (dagitemsdata?.length > 0) {
                    dagitemsdata = Object.values(_.groupBy(dagitemsdata, a => a.plaas.id));
                    nuwedaedata[dag] = {
                        ...nuwedaedata[dag],
                        items: dagitemsdata
                    };
                }
            }
            nuwedata[kultivar] = {
                ...nuwedata[kultivar],
                [week]: {
                    ...nuwedata[kultivar]?.[week],
                    ...weekskryf,
                    ...nuwedaedata
                }
            }
        }
    }

    return updateObject(state, {
        data: {
            ...state.data,
            loading: false,
            success: true,
            error: false,
            errordata: null,
            data: nuwedata,
            rawdata: nuwedata,
        }
    });
};

const setPlukbeplanWeekFailed = (state, action) => {
    return updateObject(state, {
        data: {
            ...state.data,
            loading: false,
            success: false,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            },
            data: []
        }
    });
};

const getPlukbeplanWeekDae = (state, action) => {
    return updateObject(state, {
        data: {
            ...state.data,
            loading: true,
        }
    });
};

const setPlukbeplanWeekDae = (state, action) => {
    let nuwedata = _.clone(state.data.data);
    let week = moment(state.datum).isoWeekday(state.weekstart).format("W");
    for (const item of action.data) {
        nuwedata[item.kultivar] = {
            ...nuwedata[item.kultivar],
            [week]: {
                ...nuwedata[item.kultivar]?.[week],
                [moment(item.datum).format("Y-MM-DD")]: [
                    ...nuwedata[item.kultivar]?.[week]?.[moment(item.datum).format("Y-MM-DD")],
                    item
                ]
            }
        }
    }

    return updateObject(state, {
        data: {
            ...state.data,
            loading: false,
            success: true,
            error: false,
            errordata: null,
            data: nuwedata,
            rawdata: nuwedata,
        }
    });
};

const setPlukbeplanWeekDaeFailed = (state, action) => {
    return updateObject(state, {
        data: {
            ...state.data,
            loading: false,
            success: false,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            },
            data: []
        }
    });
};

const setPlukbeplanOpstellings = (state, action) => {
    let eenheidverh = action.data.filter(item => item.kategorie === "PLUK_EENHEDEVERH");
    eenheidverh = eenheidverh.length > 0 ? eenheidverh[0] : null;

    let eenheidgekies = action.data.filter(item => item.kategorie === "PLUK_BEPLANVIEWEENHEID");
    eenheidgekies = eenheidgekies.length > 0 ? eenheidgekies[0] : null;
    let eenheidconv = eenheidverh?.verhoudings?.filter(item => item.id === eenheidgekies?.eenheid);
    eenheidconv = eenheidconv.length > 0 ? eenheidconv[0] : null;

    let weekstartt = action.data.filter(item => item.kategorie === "PLUK_BEPLANWEEKBEGIN");
    weekstartt = weekstartt.length > 0 ? weekstartt[0] : null;

    return updateObject(state, {
        weekstart: weekstartt?.dag || 1,
        weekstart_id: weekstartt?.id,
        vieweenheid: eenheidgekies?.eenheid,
        vieweenheid_id: eenheidgekies?.id,
        eenheidkg: eenheidverh?.eenheidkg || 1,
        eenhede: eenheidverh?.verhoudings || [],
        eenheidconversion: eenheidconv?.kg || 1,
        settings: {
            ...state.settings,
            loading: false,
            success: true,
            error: false,
            errordata: null,
            data: action.data
        }
    });
};

const setPlukbeplanOpstellingsFailed = (state, action) => {
    return updateObject(state, {
        settings: {
            ...state.settings,
            loading: false,
            success: false,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            },
            data: []
        }
    });
};

const setSnackbarClose = (state, action) => {
    return updateObject(state, {
        snackbar_open: false
    });
};

const setPlukbeplanOpstellingsSnackbarSuccess = (state, action) => {
    return updateObject(state, {
        snackbar_open: true,
        snackbar: {
            ...state.snackbar,
            loading: false,
            success: true,
            error: false,
            errordata: null
        }
    });
};

const setPlukbeplanOpstellingsSnackbarFailed = (state, action) => {
    return updateObject(state, {
        snackbar_open: true,
        snackbar: {
            ...state.snackbar,
            loading: false,
            success: false,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            }
        }
    });
};

const updatePlukbeplanWeek = (state, action) => {
    let nuwedata = _.cloneDeep(state.data.data);
    nuwedata[action.kultivar] = {
        ...nuwedata[action.kultivar],
        [action.week]: {
            ...nuwedata[action.kultivar]?.[action.week],
            teiken: action.data?.teiken || null,
            weekid: action.data ? { PK: action.data.PK, SK: action.data.SK } : null,
        }
    }

    return updateObject(state, {
        data: {
            ...state.data,
            loading: false,
            success: true,
            error: false,
            errordata: null,
            data: nuwedata,
            rawdata: nuwedata,
        }
    });
};

const updatePlukbeplanDag = (state, action) => {
    let nuwedata = _.cloneDeep(state.data.data);
    nuwedata[action.kultivar] = {
        ...nuwedata[action.kultivar],
        [action.week]: {
            ...nuwedata[action.kultivar]?.[action.week],
            [action.dag]: {
                ...nuwedata[action.kultivar]?.[action.week]?.[action.dag],
                teiken: action.data?.teiken || null,
                dagid: action.data ? { PK: action.data.PK, SK: action.data.SK } : null,
            }
        }
    }

    return updateObject(state, {
        data: {
            ...state.data,
            loading: false,
            success: true,
            error: false,
            errordata: null,
            data: nuwedata,
            rawdata: nuwedata,
        }
    });
};

const updatePlukbeplanDagItem = (state, action) => {
    let nuwedata = _.cloneDeep(state.data.rawdata);
    let nuweitems = Object.values(_.groupBy(action.data, a => a.plaas.id));
    nuwedata[action.kultivar] = {
        ...nuwedata[action.kultivar],
        [action.week]: {
            ...nuwedata[action.kultivar]?.[action.week],
            [action.dag]: {
                ...nuwedata[action.kultivar]?.[action.week]?.[action.dag],
                items: nuweitems
            }
        }
    }

    return updateObject(state, {
        data: {
            ...state.data,
            loading: false,
            success: true,
            error: false,
            errordata: null,
            data: nuwedata,
            rawdata: nuwedata,
        }
    });
};

const setGewasFilter = (state, action) => {
    let nuwedata = _.cloneDeep(state.data.rawdata);
    let filteredkultivars = _.cloneDeep(state.kultivars.rawdata);

    if (action.gewas) {
        nuwedata = Object.values(nuwedata).filter(item => item.gewas.id === action.gewas);
        nuwedata = _.keyBy(nuwedata, "id");
        filteredkultivars = Object.values(filteredkultivars).filter(item => item.gewas.id === action.gewas);
    }

    return updateObject(state, {
        kultivars: {
            ...state.kultivars,
            loading: false,
            success: true,
            error: false,
            errordata: null,
            data: filteredkultivars,
            rawdata: state.kultivars.rawdata
        },
        data: {
            ...state.data,
            loading: false,
            success: true,
            error: false,
            errordata: null,
            data: nuwedata,
            rawdata: state.data.rawdata
        }
    });
};


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PLUKBEPL_ADD_DATUM:
            return addDatum(state, action);
        case actionTypes.PLUKBEPL_SUBTRACT_DATUM:
            return subtractDatum(state, action);
        case actionTypes.PLUKBEPL_SET_VANDAG:
            return setVandagDatum(state, action);
        case actionTypes.PLUKBEPL_SET_DATUM:
            return setDatum(state, action);
        case actionTypes.PLUKBEPL_SET_WEEK_BEGIN:
            return setWeekBeginPlukbeplan(state, action);
        case actionTypes.GET_PLUKBEPL_KULTIVARS:
            return getPlukbeplanKultivars(state, action);
        case actionTypes.SET_PLUKBEPL_KULTIVARS:
            return setPlukbeplanKultivars(state, action);
        case actionTypes.SET_PLUKBEPL_KULTIVARS_FAILED:
            return setPlukbeplanKultivarsFailed(state, action);
        case actionTypes.GET_PLUKBEPL_WEEK:
            return getPlukbeplanWeek(state, action);
        case actionTypes.SET_PLUKBEPL_WEEK:
            return setPlukbeplanWeek(state, action);
        case actionTypes.SET_PLUKBEPL_WEEK_FAILED:
            return setPlukbeplanWeekFailed(state, action);
        case actionTypes.GET_PLUKBEPL_WEEKDAE:
            return getPlukbeplanWeekDae(state, action);
        case actionTypes.SET_PLUKBEPL_WEEKDAE:
            return setPlukbeplanWeekDae(state, action);
        case actionTypes.SET_PLUKBEPL_WEEKDAE_FAILED:
            return setPlukbeplanWeekDaeFailed(state, action);
        case actionTypes.SET_PLUKBEPL_OPSTELLINGS:
            return setPlukbeplanOpstellings(state, action);
        case actionTypes.SET_PLUKBEPL_OPSTELLINGS_FAILED:
            return setPlukbeplanOpstellingsFailed(state, action);
        case actionTypes.SET_PLUKBEPL_SNACKBAR_CLOSE:
            return setSnackbarClose(state, action);
        case actionTypes.SET_PLUKBEPL_OPSTELLINGS_SNACKBAR_SUCCESS:
            return setPlukbeplanOpstellingsSnackbarSuccess(state, action);
        case actionTypes.SET_PLUKBEPL_OPSTELLINGS_SNACKBAR_FAILED:
            return setPlukbeplanOpstellingsSnackbarFailed(state, action);
        case actionTypes.PLUKBEPL_SET_WEEKTEIKEN:
            return updatePlukbeplanWeek(state, action);
        case actionTypes.PLUKBEPL_SET_DAGTEIKEN:
            return updatePlukbeplanDag(state, action);
        case actionTypes.PLUKBEPL_SET_DAGITEM:
            return updatePlukbeplanDagItem(state, action);
        case actionTypes.PLUKBEPL_SET_GEWASFILTER:
            return setGewasFilter(state, action);
        default:
            return state;
    }
};

export default reducer;